import { compose, withProps } from 'recompose';
import { withPortlet } from 'js/components/system/Portlet';
import withLeaderBoardsReducer from '../common/withLeaderBoardsReducer';
import withSummaryUpdates from '../common/withSummaryUpdates';
import { withFetch } from '../withLeaderBoardList';
import { withListContext } from '../withContext';
import { NOTIFICATION_FIELDS } from './constants';

export const withNotificationFieldsWhitelist = withProps(
    () => ({
        notificationFieldsWhitelist: NOTIFICATION_FIELDS
    })
);

export default compose(
    withPortlet({ forLoggedIn: true }),
    withLeaderBoardsReducer,
    withListContext,
    withFetch,
    withNotificationFieldsWhitelist,
    withSummaryUpdates
);
